// extracted by mini-css-extract-plugin
module.exports = {"filterContainer":"ClosedInterventionListCard_filterContainer__2JwYB","paginationWrapper":"ClosedInterventionListCard_paginationWrapper__3DOzk"};